import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { AuthHeaderService } from '../views/authheader.service';
import { throwError as observableThrowError, Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class DwollatransferService {
  dwollaurl: string;
  constructor(private http: Http, private _headerService: AuthHeaderService) {this.dwollaurl = environment.dwollaurl; }
  SendForm(pageFilters: any) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.dwollaurl+"/transfers", pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getDwollaPayments() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.dwollaurl+"/transfers", options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
}
